{
    "stats_block_title__recommendation_count": "Number of churn warnings",
    "stats_block_title__customer_count": "Customers with churn warnings",
    "stats_block_title__total_loss": "Potential loss of sales",
    "state_block_detail__vs_last_period": "to the previous period",

    "note_body": "If you create a task for a sales recommendation, it disappears from this view",

    "insight_table__header_insight_generated_at": "Generate at",
    "insight_table__header_customer": "Customer",
    "insight_table__header_product_group": "Product group",
    "insight_table__header_ttm_delta": "Sales deviation last 12M",
    "insight_table__header_sales_last_24_months": "Turnover last 24 months",
    "insight_table__header_orders_last_24_months": "Orders last 24 months",
    "insight_table__header_reason": "Reason",
    "insight_table__header_sales_rep": "Sales Rep",

    "search_placeholder__customers": "Search for customers"
}
